"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dinfo = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var format_1 = require("@/utils/format");
var marked_1 = require("marked");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.dinfo), { symbol: state.layout.currencies.options
        .filter(function (it) { return it.key === state.layout.currencies.currentCurrencyId; })[0].symbol })); };
var mapDispatchToProps = function () { return ({}); };
exports.dinfo = function (props) {
    var renderFinding = function (price, name, props) {
        if (!price)
            return '';
        return (React.createElement("tr", { className: "c-dinfo__finding" },
            React.createElement("th", { className: "c-dinfo__ftitle", style: { display: 'block', textAlign: 'left', fontWeight: 'normal' } },
                React.createElement("span", { className: "fal fa-chart-line" }),
                "\u00A0\u00A0",
                name),
            React.createElement("td", { className: "c-dinfo__fresult" }, format_1.default.currency(price, props.symbol))));
    };
    if (!props.districtName || !props.blob)
        return null;
    return (React.createElement("div", { className: "c-dinfo" },
        React.createElement("div", { className: "c-dinfo__text" },
            props.districtName ? (React.createElement("div", { className: "c-dinfo__titlerow" },
                React.createElement("div", { className: "c-dinfo__title" },
                    props.nameAbout,
                    " ",
                    props.districtName),
                React.createElement("div", { className: "c-dinfo__link" },
                    React.createElement("a", { className: "o-btn o-btn--flat", href: props.url },
                        props.nameViewMore,
                        " ",
                        props.districtName)))) : null,
            React.createElement("div", { className: "c-dinfo__blob", dangerouslySetInnerHTML: { __html: marked_1.marked.parse(props.blob) } })),
        (props.averageSalesPrice || props.averageAskingRental) ? (React.createElement("table", { className: "c-dinfo__findings" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { className: "c-dinfo__name", style: { display: 'block', textAlign: 'left', fontWeight: 'normal' } },
                        React.createElement("span", { className: "fal fa-tag" }),
                        "\u00A0\u00A0",
                        props.namePropertyPriceIn,
                        React.createElement("br", null),
                        React.createElement("span", { className: "u-bold u-big" },
                            " ",
                            props.districtName)))),
            React.createElement("tbody", { className: "c-dinfo__rows" },
                renderFinding(props.averageSalesPrice, props.nameAverageSalesPrice, props),
                renderFinding(props.averageAskingRental, props.nameAverageAskingRental, props)),
            React.createElement("tfoot", { className: "c-dinfo__terms" },
                React.createElement("tr", null,
                    React.createElement("td", null,
                        React.createElement("span", { className: "fal fa-exclamation-circle" }),
                        "\u00A0",
                        props.nameTerms))))) : null));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.dinfo);
